import { Scene } from "phaser";
import Game from "./Game";

export default class BootScene extends Scene {
  constructor() {
    super("BootScene");
  }

  preload() {
    // Precarica le immagini dello span più piccolo
    const minSpan = Game.spans[0];
    const a = Game.frames;
    for (let x = 0; x < a; x++) {
      this.load.image("image" + minSpan + "_" + x, Game.folderPath + minSpan + "/" + Game.prefix + Game.to3(x) + Game.suffix);
    }
  }

  create() {
    this.scene.start("MainScene");
  }

  static getCurrentSpan(scene) {
    const bounds = scene.scale.canvasBounds;
    const canvasHeight = bounds.height;
    // Prende lo span in base all'altezza corrente del canvas
    const a = Game.spans;
    let span = -1;
    for (let x = 0; x < a.length; x++) {
      if (canvasHeight <= a[x]) {
        span = a[x];
        break;
      }
    }
    if (span === -1) {
      span = a[a.length - 1];
    }
    return span;
  }
}

